import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  const trainers = [
    {
      name: "ALEX CARTER",
      role: "Strength & Conditioning Coach",
      img: "https://images.pexels.com/photos/5037404/pexels-photo-5037404.jpeg",
      expertise: ["Strength", "Hypertrophy", "Powerlifting"],
    },
    {
      name: "MIA RODRIGUEZ",
      role: "Fat Loss & HIIT Specialist",
      img: "https://images.pexels.com/photos/7055647/pexels-photo-7055647.jpeg",
      expertise: ["HIIT", "Weight Loss", "Cardio Training"],
    },
    {
      name: "RYAN BROOKS",
      role: "Functional Training Expert",
      img: "https://images.pexels.com/photos/2011383/pexels-photo-2011383.jpeg",
      expertise: ["Mobility", "Balance", "Functional Strength"],
    },
    {
      name: "EMMA STONE",
      role: "Yoga & Flexibility Coach",
      img: "https://images.pexels.com/photos/3823151/pexels-photo-3823151.jpeg",
      expertise: ["Yoga", "Flexibility", "Breathwork"],
    },
    {
      name: "DAVID HUNT",
      role: "Body Recomposition Coach",
      img: "https://images.pexels.com/photos/3912953/pexels-photo-3912953.jpeg",
      expertise: ["Aesthetics", "Strength", "Diet Planning"],
    },
  ];

  return (
    <div className="trainers-page">

      {/* ---------------- HERO ---------------- */}
      <section className="trainers-hero">
        <h1>TRAINERS</h1>
        <p>Meet the experts who build champions.</p>
        <span className="red-line"></span>
      </section>



      {/* ---------------- TRAINER GRID ---------------- */}
      <section className="trainer-grid-section">
        <h2 className="section-title">OUR EXPERT TEAM</h2>

        <div className="trainer-grid">
          {trainers.map((trainer, i) => (
            <div className="trainer-card" key={i}>
              <img src={trainer.img} alt={trainer.name} />

              <div className="trainer-overlay">
                <h3>{trainer.name}</h3>
                <p>{trainer.role}</p>

                <div className="tags">
                  {trainer.expertise.map((tag, j) => (
                    <span key={j}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>



      {/* ---------------- PHILOSOPHY SECTION ---------------- */}
      <section className="trainer-philosophy">
        <h1>TRAIN SMART. TRAIN HARD.</h1>
        <p>
          Every ACE coach is certified, experienced, and dedicated to pushing you 
          beyond your limits with structured, safe, and effective training.
        </p>
      </section>



      {/* ---------------- CTA ---------------- */}
      <section className="trainers-cta">
        <h1>START TRAINING WITH THE BEST.</h1>
        <button>Book a Session</button>
      </section>

    </div>
  );
};

export default Trainers;
